import fileService from '@/shared/file/file-service';
import { db } from '@/shared/firebase/firebase-init';
import teamModel from '@/entities/team/team-model';

const KEY_TEAMS = 'teams'
const KEY_CLUBS = 'clubs'

export default {
  list(clubId) {
    return new Promise((resolve) => {
      // eslint-disable-next-line
      db.ref(KEY_CLUBS).child(clubId).child(KEY_TEAMS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          list.push(childSnapshot.val())
        });
        resolve(list)
      });
    });
  },

  save(model, loggedUser) {
    if (model.id) {
      return this.update(model, loggedUser);
    }

    return this.create(model, loggedUser);
  },

  find(id) {
    return new Promise((resolve, reject) => {
      // eslint-disable-next-line
      db.ref(KEY_TEAMS).child(id).once('value').then((snapshot) => { 
        const model = snapshot.val();
        
        if (!model) {
          return null;
        }

        fileService.fillDownloadURLs(
          KEY_TEAMS,
          model,
          [
            'pictures',
          ]
        ).then((modelR) => {
          resolve(modelR)
        }).catch((error) => {
          reject(error)
        });
      })
    });
  },

  destroy(id) {
    return new Promise((resolve, reject) => {
      db.ref(KEY_TEAMS).child(id).set(null, (error) => {
        if (error) {
          // The write failed...
          reject(error)
        } else {
          // Data saved successfully!
          resolve()
        }
      })
    })
  },

  update(model) {
    return new Promise((resolve, reject) => {
      fileService
      .uploadAll(KEY_TEAMS, model, [
          'pictures',
        ])
        .then(() => {
          db.ref(KEY_TEAMS).child(model.id).set(teamModel.forUpdate(model), (error) => {
            if (error) {
              // The write failed...
              reject(error)
            } else {
              // Data saved successfully!
              resolve()
            }
          })
        }).catch((error) => {
          reject(error)
        });
      });
  },

  create(model) {
    const modelToSave = {
      ...model,
      id: db.ref(KEY_TEAMS).push().key
    };

    return new Promise((resolve, reject) => {
      fileService.uploadAll(KEY_TEAMS, modelToSave, [
        'pictures',
      ])
      .then(() => {
        db.ref(KEY_CLUBS).child(model.club.id).child(KEY_TEAMS).child(modelToSave.id).set(teamModel.forCreate(modelToSave), (error) => {
          if (error) {
            // The write failed...
            reject(error)
          } else {
            // Data saved successfully!
            resolve()
          }
        });
      }).catch((error) => {
        reject(error)
      });
    });
  },

  listOptions() {
    return new Promise((resolve) => {
      db.ref(KEY_TEAMS).once('value').then((snapshot) => { 
        const list = []
        snapshot.forEach(childSnapshot => {
          const modelOption = {}
          modelOption.id = childSnapshot.key
          modelOption.label = childSnapshot.val().name

          list.push(modelOption)
        });
        resolve(list)
      });
    });
  }
};



// WEBPACK FOOTER //
// ./src/entities/club/club-team-list/club-team-list-service.js